import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'arrayToString',
    standalone: true
})
export class ArrayToStringPipe implements PipeTransform {

  transform(value: string[] | null | undefined, sep: string): string {
    if (value !== undefined && value !== null) {
      return value.join(sep);
    }
    return '';
  }
}
